import React from 'react'
import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import Grid2 from '@mui/material/Unstable_Grid2/Grid2';
import { DateCellStyling,ContainerStyling,HeadingStyling,TableStyling,TableRowStyling } from './BiogTableStyles';

export default function BiogGrants() {
  const { t } = useTranslation('common');

  return (
    <Grid2 flexDirection="row" sx={ContainerStyling}>
        <TableContainer>
          <Table sx={TableStyling} aria-label="simple table">
            <TableBody>
              <TableRow
                key={"1"}
                sx={TableRowStyling}
              >
                <TableCell component="td" padding="none" scope="row" sx={DateCellStyling}>
                  1985
                </TableCell>
                <TableCell align="left" padding="none" sx={{border:0,pl:1}}>
                  <Box sx={{fontWeight : 'bold'}} component='span'>{"Metal Arts Guild Award"}</Box>
                  <Box sx={{fontWeight : 'normal'}} component='span'>, Design Frontiers '85, Richmond Art Center, Richmond, CA, Jury: Peter Gutkin und Elsa Cameron</Box>
                </TableCell>
              </TableRow>
              <TableRow
                key={"2"}
                sx={TableRowStyling}
              >
                <TableCell component="td" padding="none" scope="row" sx={DateCellStyling}>
                  1984
                </TableCell>
                <TableCell align="left" padding="none" sx={{border:0,pl:1}}>
                  <Box sx={{fontWeight : 'bold'}} component='span'>{"Award for Excellence"}</Box>
                  <Box sx={{fontWeight : 'normal'}} component='span'>, Conference of Northern California Handweavers</Box>
                </TableCell>
              </TableRow>
              <TableRow
                key={"3"}
                sx={TableRowStyling}
              >
                <TableCell component="td" padding="none" scope="row" sx={DateCellStyling}>
                  1983
                </TableCell>
                <TableCell align="left" padding="none" sx={{border:0,pl:1}}>
                  <Box sx={{fontWeight : 'bold'}} component='span'>{"Fourth Prize Sculpture"}</Box>
                  <Box sx={{fontWeight : 'normal'}} component='span'>, The Art Marketing Letter's Fall Competition '83 Jury: Mary Jane Jacobs, Hedy B. Landmann und Randy R. Lubow</Box>
                </TableCell>
              </TableRow>
              <TableRow
                key={"4"}
                sx={TableRowStyling}
              >
                <TableCell component="td" padding="none" scope="row" sx={DateCellStyling}>
                  1980
                </TableCell>
                <TableCell align="left" padding="none" sx={{border:0,pl:1}}>
                  <Box sx={{fontWeight : 'bold'}} component='span'>{"Kunstkommission Baselland"}</Box>
                  <Box sx={{fontWeight : 'normal'}} component='span'>, Liestal - Ankauf von drei Bildern</Box>
                </TableCell>
              </TableRow>
              <TableRow
                key={"5"}
                sx={TableRowStyling}
              >
                <TableCell component="td" padding="none" scope="row" sx={DateCellStyling}>
                  1977
                </TableCell>
                <TableCell align="left" padding="none" sx={{border:0,pl:1}}>
                  <Box sx={{fontWeight : 'bold'}} component='span'>{"Stipendium der Bata Schuh Stiftung"}</Box>
                  <Box sx={{fontWeight : 'normal'}} component='span'> für einen Studienaufenthalt in Indien</Box>
                </TableCell>
              </TableRow>
              <TableRow
                key={"6"}
                sx={TableRowStyling}
              >
                <TableCell component="td" padding="none" scope="row" sx={DateCellStyling}>
                1974-76
                </TableCell>
                <TableCell align="left" padding="none" sx={{border:0,pl:1}}>
                  <Box sx={{fontWeight : 'bold'}} component='span'>{"Stipendium der dänischen Regierung"}</Box>
                  <Box sx={{fontWeight : 'normal'}} component='span'> für einen Studienaufenthalt an der Königlichen Dänischen Kunstakademie in Kopenhagen, Dänemark</Box>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
    </Grid2>
  )
}
